import { render, staticRenderFns } from "./GroupInformationAboutStudentLeavingReport.vue?vue&type=template&id=983dde82&"
import script from "./GroupInformationAboutStudentLeavingReport.vue?vue&type=script&lang=js&"
export * from "./GroupInformationAboutStudentLeavingReport.vue?vue&type=script&lang=js&"
import style0 from "./GroupInformationAboutStudentLeavingReport.vue?vue&type=style&index=0&id=983dde82&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports